import Schwoop from './Schwoop';

export { default as RoutedSchwoop } from './RoutedSchwoop';
export default Schwoop;
